import { useState } from "react";
import type { OnlineOperator } from "../../shared/support";

export function OnlineTeam({ operators }: { operators: OnlineOperator[] }) {
  if (!operators.length) return null;
  return <div className="online-team" aria-label="Store team online">
    <div className="online-team-members">
      {operators.map((operator, index) => <OnlineProfile key={`${index}:${operator.name}:${operator.photoUrl}`} operator={operator} />)}
    </div>
    <small>Online · Our team can help</small>
  </div>;
}

function OnlineProfile({ operator }: { operator: OnlineOperator }) {
  const [failed, setFailed] = useState(false);
  return <span className="online-team-member" title={`${operator.name} · Online`}>
    <span className="online-team-avatar" aria-hidden="true">
      {operator.photoUrl && !failed ? <img src={operator.photoUrl} alt="" onError={() => setFailed(true)} /> : operator.name.slice(0, 1).toUpperCase()}
    </span>
    <span>{operator.name}</span>
  </span>;
}
